<script setup></script>
<template>
	<div class="line"></div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.line {
	height: 0.6rem;
	box-shadow: inset 0 4px 2px 0 rgba(255, 255, 255, 0.25), inset 0 -4px 4px 0 rgba(0, 0, 0, 0.19);
	background: var(--brand-accent-2-100);
}
</style>
